import React from 'react';
import { Empty, Select } from 'antd';
import { useFieldController } from '../../../../helpers/formManager';
import Field from '../../shared/ui/Field';
import { fieldPathBuilders } from '../../shared/configs/acceptanceForm';
import { useDeskNamesData } from '../../services/queries/deskNames';
import styles from './index.module.scss';

const { Option } = Select;

const createFieldName = fieldPathBuilders.desk.name;

const SelectDeskName = ({
  deskIndex,
  names,
  notDeskNamesContent: NotDeskNamesContent,
  renderActionsForOption,
  disabled = false,
}) => {
  const { isFetching } = useDeskNamesData();

  const { field, fieldState } = useFieldController({
    name: createFieldName(deskIndex),
    rules: { required: 'Укажите номер стола' },
  });

  return (
    <Field.Memoized
      type={Field.types.select}
      formItemLabel="Номер стола ответственного"
      disabled={disabled || isFetching}
      required
      value={isFetching ? undefined : field.value}
      onChange={field.onChange}
      errorMessage={fieldState.error?.message}
      placeholder="Выбрать из списка"
      style={{ width: '100%' }}
      labelInValue
      optionLabelProp="label"
      notFoundContent={
        names?.length ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Ничего не найдено"
          />
        ) : (
          <NotDeskNamesContent />
        )
      }
    >
      {names?.map((item) => (
        <Option
          value={item.id}
          key={item.id}
          className={styles.option}
          label={item.name}
        >
          {item.name}
          {typeof renderActionsForOption === 'function' &&
            renderActionsForOption(item)}
        </Option>
      ))}
    </Field.Memoized>
  );
};

export default SelectDeskName;
